import { Flex, FlexProps } from '@mantine/core';
import styled from 'styled-components';

export const StyledSubBreadcrumbs = styled(Flex)<FlexProps>`
	.mantine-Text-root:not(:last-child) {
		color: ${({ theme }) => theme.v3.colors.dark[0]};
	}
`;

export const ButtonWrapper = styled.div`
	margin: auto 0.5rem 0.5rem 0;
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`;

export const DrawFieldContainer = styled.div`
	height: 100%;
	display: flex;
	width: 100%;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
`;

export const ClassifierForm = styled.form`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
`;

export const FieldWrapper = styled.div`
	width: 100%;
`;
